// extracted by mini-css-extract-plugin
module.exports = {"PricingTable":"PricingTable_PricingTable__39KNF"};